(function () {
  'use strict';

  const TRIGGER_VARIANT_ID = 48991626952953;
  const CART_MUTATION_PATH = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${shopRoot}cart.js`;
  const addUrl = `${shopRoot}cart/add.js`;
  const changeUrl = `${shopRoot}cart/change.js`;
  const nativeFetch = window.fetch.bind(window);
  let syncQueue = Promise.resolve();
  let syncing = false;

  function requestPath(input) {
    try {
      const value = typeof input === 'string' ? input : input && input.url;
      return new URL(value, window.location.origin).pathname + new URL(value, window.location.origin).search;
    } catch (error) {
      return '';
    }
  }

  function propertyValue(properties, name) {
    if (!properties) return '';
    const target = name.toLowerCase();
    const key = Object.keys(properties).find((item) => item.toLowerCase() === target);
    return key ? String(properties[key] || '') : '';
  }

  function parseWidth(value) {
    const match = String(value).match(/Width:\s*(\d+(?:\.\d+)?)\s*(?:(\d+)\s*\/\s*(\d+))?/i);
    if (!match) return NaN;

    const whole = Number(match[1]);
    const numerator = Number(match[2] || 0);
    const denominator = Number(match[3] || 1);
    return whole + (denominator ? numerator / denominator : 0);
  }

  function lineRequiresDhl(item) {
    if (Number(item.variant_id) === TRIGGER_VARIANT_ID) return false;

    const delivery = propertyValue(item.properties, 'PICK UP or DELIVERY');
    if (!/Delivery to my door/i.test(delivery)) return false;

    const direction = propertyValue(item.properties, 'OPEN DIRECTION');
    const width = parseWidth(propertyValue(item.properties, 'DIMENSIONS'));
    if (!Number.isFinite(width)) return false;

    if (/OPENS BOTH SIDES/i.test(direction)) {
      return width >= 213 && width <= 236;
    }

    if (/OPENS TO THE (LEFT|RIGHT)/i.test(direction)) {
      return width >= 107 && width <= 118;
    }

    return false;
  }

  async function fetchJson(url, options) {
    const response = await nativeFetch(url, options);
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  async function changeLine(key, quantity) {
    return fetchJson(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  async function synchronizeDhlTrigger() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await fetchJson(cartUrl, { headers: { Accept: 'application/json' } });
      const triggerLines = cart.items.filter((item) => Number(item.variant_id) === TRIGGER_VARIANT_ID);
      const needsTrigger = cart.items.some(lineRequiresDhl);

      if (needsTrigger && triggerLines.length === 0) {
        await fetchJson(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: TRIGGER_VARIANT_ID, quantity: 1 }] })
        });
      } else if (!needsTrigger && triggerLines.length) {
        for (const line of triggerLines) await changeLine(line.key, 0);
      } else if (needsTrigger && triggerLines.length) {
        await changeLine(triggerLines[0].key, 1);
        for (const line of triggerLines.slice(1)) await changeLine(line.key, 0);
      }
    } catch (error) {
      console.error('[DHL oversize shipping]', error);
    } finally {
      syncing = false;
    }
  }

  function queueSynchronization() {
    syncQueue = syncQueue.catch(function () {}).then(synchronizeDhlTrigger);
    return syncQueue;
  }

  window.fetch = async function () {
    const args = Array.prototype.slice.call(arguments);
    const response = await nativeFetch.apply(null, args);

    if (response.ok && CART_MUTATION_PATH.test(requestPath(args[0]))) {
      await queueSynchronization();
    }

    return response;
  };

  const NativeXMLHttpRequest = window.XMLHttpRequest;
  if (NativeXMLHttpRequest) {
    const nativeOpen = NativeXMLHttpRequest.prototype.open;
    NativeXMLHttpRequest.prototype.open = function (method, url) {
      this.__dhlCartMutation = CART_MUTATION_PATH.test(requestPath(url));
      if (this.__dhlCartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 400) queueSynchronization();
        });
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSynchronization, { once: true });
  } else {
    queueSynchronization();
  }
})();
